import { render } from "./Bean.vue?vue&type=template&id=1bd62b89"
import script from "./Bean.vue?vue&type=script&lang=js"
export * from "./Bean.vue?vue&type=script&lang=js"

import "./Bean.vue?vue&type=style&index=0&id=1bd62b89&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__